import "./App.css";
import "./fonts/fonts.css";

import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

// Error Page
import ErrorPage from "./error";
import NotFoundPage from "./routes/404";

// Routes
import Root from "./routes/root";
import IndexPage from "./routes/index";
import LoginPage from "./routes/login";
import SignupPage, { action as registerAction } from "./routes/signup";
import { AuthProvider } from "./contexts/auth-context";
import ProblemRoot from "./routes/problem/problem";
// import CreateProblemWizard from "./routes/problem/create-problem-wizard";
import CreateProblemWizard from "./routes/problem/create-problem";
import AnswerQuestions from "./routes/problem/answer-questions";
import ProblemResults from "./routes/problem/problem-results";
import UpdateAlternatives from "./routes/problem/update-alternatives";
import About from "./routes/about";
import MyDecisions from "./routes/my-decisions-v2";
import ProblemType from "./routes/problem/problem-type";
import ForgetPasswordPage from "./routes/forget-password";
import UpdatePasswordPage from "./routes/update-password";
import UsersTable from "./routes/admin/users-table";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "",
        element: <IndexPage />,
      },
      {
        path: "/my-decisions",
        element: <MyDecisions />,
      },
      {
        path: "/users-table",
        element: <UsersTable />,
      },
      {
        path: "/about",
        element: <About />,
      },
      {
        path: "/login",
        element: <LoginPage />,
      },
      {
        path: "/forgot-password",
        element: <ForgetPasswordPage />,
      },
      {
        path: "/reset-password",
        element: <UpdatePasswordPage />,
      },
      {
        path: "/signup",
        element: <SignupPage />,
        action: registerAction,
      },
      {
        path: "/problem",
        element: <ProblemRoot />,
        children: [
          {
            path: "/problem/type",
            element: <ProblemType />,
          },
          {
            path: "/problem/create",
            element: <CreateProblemWizard />,
          },
          {
            path: "/problem/alternatives",
            element: <UpdateAlternatives />,
          },
          {
            path: "/problem/answer",
            element: <AnswerQuestions />,
          },
          {
            path: "/problem/result",
            element: <ProblemResults />,
          },
        ],
      },
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </React.StrictMode>,
);
